export const CHECKOUT_URL =
  "https://checkout.ebookpoint.shop/cart/59837273407569:1";

export const SUPPORT_EMAIL = "EbookDreamShop@gmail.com";

export const PRICE = "$19.990";
export const OLD_PRICE = "$58.990";

export const PRODUCT_IMAGE =
  "https://cdn.magicpatterns.com/uploads/kSQbx3iLzrRC94Xpqq6nZ1/ChatGPT_Image_Jul_17,_2026,_04_48_37_PM.png";

export const BONO_IMAGES = {
  bono1: "https://cdn.magicpatterns.com/patterns/generated-images/f204545a-3020-4015-a433-13eed6e1fe8d.jpg",
  bono2: "https://cdn.magicpatterns.com/patterns/generated-images/34791d15-9d51-47c2-a7eb-4a748f640474.jpg",
  bono3: "https://cdn.magicpatterns.com/patterns/generated-images/de497e4b-a45a-4d56-b351-4cff75bcb9d4.jpg",
  bono5: "https://cdn.magicpatterns.com/patterns/generated-images/8abdbae8-b4f5-41f5-b668-f36fbab11190.jpg",
};

export const TOTAL_CUPOS = 200;

export function scrollToOffer() {
  const el = document.getElementById("oferta");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}
